import { render, staticRenderFns } from "./zh-en-titleItem.vue?vue&type=template&id=d486ffc2&scoped=true&"
import script from "./zh-en-titleItem.vue?vue&type=script&lang=js&"
export * from "./zh-en-titleItem.vue?vue&type=script&lang=js&"
import style0 from "./zh-en-titleItem.vue?vue&type=style&index=0&id=d486ffc2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d486ffc2",
  null
  
)

component.options.__file = "zh-en-titleItem.vue"
export default component.exports